import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { Utility } from '../../../common/utility';
@Injectable()
export class SaveConsultationService {
  constructor(private baseService: BaseService) {
  }

  getAdministerVaccineStatus(consultationId) {
    let url = Utility.stringFormat(ConsultationUrl.GET_ADMINISTER_VACCINE_STATUS, [consultationId]);
    return this.baseService.getData(url);
  }

  saveConsultation(consultationId, data, isMoveNextStep) {
    let url = Utility.stringFormat(ConsultationUrl.SAVE_CONSULTATION, [consultationId]);
    url += '?isMoveNextStep='+ isMoveNextStep;
    return this.baseService.postData(url, data);
  }
  isPatientHasPerscriptions(consultationId) {
    const url = Utility.stringFormat(ConsultationUrl.IS_PATIENT_HAS_PRESCRIPTION, [consultationId]);
    return this.baseService.getData(url);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/save-consultation/save-consultation.service.ts